import { FC, ReactElement } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const PrivateTableByInvitationConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const redirectToLobby = useRedirectToLobbyCallbackConnected();
  const currentPopupData = usePopupSlice.currentPopupData();
  const isPopUpVisible = Boolean(currentPopupData?.popUpInGame);
  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        if (isPopUpVisible) {
          redirectToLobby();
        } else {
          dispatch(popupActions.dismissPopup(PopupType.ByInvitation));
        }
      }}
    />,
  ];

  return (
    <BlockingModalContent title={<L10nText tk="BY_INVITATION" />} actions={action}>
      <L10nText tk="RECEIVED_INVITATION" />
    </BlockingModalContent>
  );
};
